import React from 'react';
import { EmptyItemSC } from './empty-item.styled';
import { ReactComponent as AddIcon } from '../../../../../../assets/svg/add_e_visit.svg';
import rafSchd from 'raf-schd';
import { IAddConfig, ICalendarEvent } from '../../../../../../components/ui/calendar/calendars';
import { TExistingEVisitRule } from '../../../../../../types/e-visits';
import { WCS } from '../../../../../../components/ui/calendar/calendar-week/week-utils';
import { addMinutes, format } from 'date-fns';
import { FormattedMessage } from 'react-intl';

function calculateTimeOffset(e: React.MouseEvent) {
  const rect = e.currentTarget.getBoundingClientRect();
  const minutes = (e.clientY - rect.top) / WCS.minuteHeight;
  return Math.floor(minutes / WCS.minSelectInterval) * WCS.minSelectInterval;
}

interface IMenuPosState {
  x: number;
  y: number;
  time?: Date;
}

interface EmptyItemProps {
  item: ICalendarEvent<TExistingEVisitRule>;
  onClick: (config: IAddConfig<TExistingEVisitRule>) => void;
}

const EmptyItem: React.FunctionComponent<EmptyItemProps> = ({ item, onClick }) => {
  const [mousePos, setMousePos] = React.useState<IMenuPosState>({ x: 0, y: 0 });
  const setThrottled = React.useRef(rafSchd(setMousePos)).current;

  const _onMouseMove = React.useCallback(
    (e: React.MouseEvent) => {
      const rect = e.currentTarget.getBoundingClientRect();
      const clickedTime = addMinutes(new Date(item.start), calculateTimeOffset(e));
      setThrottled({
        x: e.clientX - rect.left,
        y: e.clientY - rect.top,
        time: clickedTime,
      });
    },
    [setThrottled, item.start],
  );

  return (
    <EmptyItemSC
      onMouseMove={_onMouseMove}
      onClick={(e) => {
        const clickedTime = addMinutes(new Date(item.start), calculateTimeOffset(e));

        onClick({
          eventData: item.eventData,
          start: clickedTime.toISOString(),
          end: addMinutes(clickedTime, WCS.minSelectInterval).toISOString(),
          minTime: item.start,
          maxTime: item.end,
          enableGestures: true,
        });
      }}
    >
      <div
        className="content"
        style={{
          transform: `translate(0, calc(${mousePos.y}px - 50%))`,
        }}
      >
        <div className="text">
          <FormattedMessage id="calendar_edit_add_action" />
        </div>
        <AddIcon />
        <div className="text">{mousePos.time ? format(mousePos.time, 'HH:mm') : ''}</div>
      </div>
    </EmptyItemSC>
  );
};

export default React.memo(EmptyItem);
